// TT-137: keep a just-completed profile visible across reloads.
//
// The host's auth gate (and DIP) read birthdate/phone from the decoded idToken,
// which stays stale until the user's next login (completing the profile sets the
// Cognito attributes but doesn't reissue the current token). We persist the saved
// values — scoped to the user's `sub` so a different account on the same browser
// never inherits them — and authStore merges them into the in-memory user until
// the token itself carries them. Deterministic and reload-safe: no token refresh
// or re-login required.

const STORAGE_KEY = 'pf-profile-completion';

export type ProfileOverride = {
  sub: string;
  birthdate: string;
  phone_number: string;
};

export function getProfileOverride(): ProfileOverride | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as Partial<ProfileOverride>;
    if (parsed?.sub && parsed.birthdate && parsed.phone_number) {
      return parsed as ProfileOverride;
    }
    return null;
  } catch {
    return null;
  }
}

export function setProfileOverride(override: ProfileOverride): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(override));
  } catch {
    // ignore unavailable / quota-exceeded localStorage
  }
}

export function clearProfileOverride(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
